var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MDCSnackbarFoundation } from '@material/snackbar';
import { MButton } from '../button/Button';
import { noop } from '../util';
import * as u from '../util/dom';
import WithRender from './Snackbar.html';
export const ACTION_EVENT = 'action';
export const SNACKBAR_TYPE = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
};
// Events
export const { CLOSING_EVENT, CLOSED_EVENT, OPENING_EVENT, OPENED_EVENT } = MDCSnackbarFoundation.strings;
// Snackbar type classes
const classes = {
    success: 'mdc-snackbar--success',
    error: 'mdc-snackbar--error',
    info: 'mdc-snackbar--info',
    warn: 'mdc-snackbar--warn'
};
// When the snackbar should closed automatically by default after 3sec
export const SNACKBAR_TIMEOUT = 4000;
function makeSnackbarAdaptor(vm) {
    return {
        addClass: u.addClass(vm),
        removeClass: u.removeClass(vm),
        announce: noop,
        notifyOpening: () => vm.$emit(OPENING_EVENT),
        notifyOpened: () => vm.$emit(OPENED_EVENT),
        notifyClosing: () => vm.$emit(CLOSING_EVENT),
        notifyClosed: (reason) => {
            if (reason === 'action') {
                vm.$emit(ACTION_EVENT);
            }
            vm.$emit(CLOSED_EVENT);
        },
    };
}
let Snackbar = class Snackbar extends Vue {
    constructor() {
        super(...arguments);
        this.classes_ = {};
    }
    mounted() {
        document.body.appendChild(this.$el);
        const vm = this;
        vm.foundation = new MDCSnackbarFoundation(makeSnackbarAdaptor(vm));
        // Initialize snackbar component.
        vm.foundation.init();
        this.onTimeoutProp();
    }
    open() {
        this.setSnackbarType();
        this.foundation.open();
    }
    dismiss() {
        this.foundation.close();
    }
    isOpened() {
        return this.foundation.isOpen();
    }
    setSnackbarType() {
        const vm = this;
        const el = vm.$el;
        // Remove if some specific snackbar type class exist
        if (u.hasClass(el, classes.success)) {
            u.removeClass(vm, classes.success);
        }
        else if (u.hasClass(el, classes.error)) {
            u.removeClass(vm, classes.error);
        }
        else if (u.hasClass(el, classes.info)) {
            u.removeClass(vm, classes.info);
        }
        else if (u.hasClass(el, classes.warn)) {
            u.removeClass(vm, classes.warn);
        }
        if (vm.type) {
            // Add the class to snackbar
            u.addClass(vm, classes[vm.type]);
        }
    }
    onTimeoutProp() {
        this.foundation.setTimeoutMs(this.timeout);
    }
    beforeDestroy() {
        this.foundation.destroy();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], Snackbar.prototype, "type", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], Snackbar.prototype, "action", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], Snackbar.prototype, "message", void 0);
__decorate([
    Prop({ default: SNACKBAR_TIMEOUT }),
    __metadata("design:type", Number)
], Snackbar.prototype, "timeout", void 0);
__decorate([
    Watch('timeout'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Snackbar.prototype, "onTimeoutProp", null);
Snackbar = __decorate([
    WithRender,
    Component({
        components: {
            'mom-button': MButton
        }
    })
], Snackbar);
export { Snackbar };
//# sourceMappingURL=Snackbar.js.map